import React from 'react';
import styles from './LoadingSpinner.module.scss';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  centered?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', centered = false }) => {
  return (
    <div className={`${styles.wrapper} ${centered ? styles.centered : ''}`}>
      <div className={`${styles.spinner} ${styles[size]}`} aria-label="Indlæser..." />
    </div>
  );
};

export default LoadingSpinner;
